/** Текст ошибки ручки раздела «Себестоимость» для человека. */
import { extractErrorMessage } from "@/lib/api-errors";
import type { XlsxRowError } from "@/api/purchasePrices";

/** Текст ошибки ручки: статус + причина бэка (`detail`), чтобы 404/409/502 были различимы. */
export function apiErrorText(err: unknown): string {
  const status = (err as { response?: { status?: number } })?.response?.status;
  const detail = (err as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  const msg =
    detail && typeof detail === "object" && !Array.isArray(detail) && "message" in detail
      ? String((detail as { message: unknown }).message)
      : extractErrorMessage(err);
  return status ? `HTTP ${status}: ${msg}` : msg;
}

/** Построчные ошибки 422 загрузки xlsx (`{detail: {message, errors}}`); другой ответ — null. */
export function xlsxErrors(err: unknown): { message: string; errors: XlsxRowError[] } | null {
  const e = err as { response?: { status?: number; data?: { detail?: unknown } } };
  if (e?.response?.status !== 422) return null;
  const d = e.response.data?.detail as { message?: unknown; errors?: unknown } | undefined;
  if (!d || typeof d !== "object" || !Array.isArray(d.errors)) return null;
  return { message: String(d.message ?? ""), errors: d.errors as XlsxRowError[] };
}
